import { API_SCENES } from '../utils/urls';
import { axios, get, post, put } from './baseAxios';

const url = API_SCENES;

export const getScene = (id): Promise<any> => get(`${url}/${id}`);
export const getScenes = (request): Promise<any> => get(url, request);
export const updateScene = (id, request): Promise<any> => put(`${url}/${id}`, request);
export const createScene = (request): Promise<any> => post(url, request);
export const deleteScene = (id): Promise<any> => axios.delete(`${url}/${id}`);
export const deleteScenes = (ids): Promise<any> => axios.delete(`${url}`, { params: { ids } });
export const retryCreateScene = (id): Promise<any> => axios.post(`${url}/${id}/retry-generate`);
export const checkSceneUsage = (id): Promise<any> => axios.get(`${url}/${id}/check-usage`);
export const updatePano = (id, request): Promise<any> => axios.put(`${url}/${id}/update-pano`, request);
